import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "modelNumber";

const modelNumberUrl = "/api/machines/MachineModelNumber";
export const modelNumberLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Model",
    url: modelNumberUrl,
  }
);
